import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarensonrentinmumbai() {



  const cardData =
  {
    keyword: 'Kia Carens On Rent in Mumbai',
    heading: 'Shambhu Cabs: Kia Carens On Rent in Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Kia Carens On Rent in Mumbai, providing safe, comfortable, and stylish travel options for families, corporate travelers, business groups, and city commuters. Our well-maintained Kia Carens vehicles offer spacious seating, ample luggage space, and modern amenities — ideal for airport transfers, corporate commutes, outstation trips, and city rides. With experienced chauffeurs, flexible one-way and round-trip rental options, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs ensures a smooth, stress-free, and dependable travel experience. For comfort, convenience, and reliability, Shambhu Cabs is your go-to choice for Kia Carens rentals in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic monument overlooking the Arabian Sea. Constructed to commemorate the visit of King George V and Queen Mary, it features grand Indo-Saracenic arches and is a hub for tourists taking ferry rides to Elephanta Island. The waterfront promenade is lively with street vendors, photographers, and performers, offering a blend of history, culture, and coastal charm. Evening illumination enhances its majestic appeal."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural marvel combining Victorian Gothic Revival and Indian traditional styles. Built in 1887, it remains one of India’s busiest railway stations. Its domes, stained glass windows, turrets, and intricately carved stonework make it a visual delight. The building symbolizes Mumbai’s colonial past and continues to serve as a major transport hub connecting millions daily."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km-long boulevard along the Arabian Sea. Famous for its Art Deco buildings and sunset views, it attracts joggers, tourists, and photographers. Evening lights make the curved promenade resemble a necklace of sparkling gems. The sea breeze, bustling street food stalls, and vibrant atmosphere make it ideal for leisure walks, relaxation, and experiencing Mumbai’s urban coastal life."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of India’s most revered temples dedicated to Lord Ganesha. Known for fulfilling devotees’ wishes, the temple features a gold-plated sanctum, intricately carved doors, and a vibrant spiritual atmosphere. During Ganesh Chaturthi, it hosts grand processions, music, and cultural events. Thousands of visitors, including celebrities, come for darshan daily, making it a spiritual landmark of Mumbai."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on a small islet in the Arabian Sea, is a beautiful Indo-Islamic mosque and tomb of Sufi saint Pir Haji Ali Shah Bukhari. Connected by a narrow causeway accessible during low tide, it offers mesmerizing sea views. The white marble structure, religious significance, and peaceful surroundings attract devotees and tourists alike, reflecting Mumbai’s multicultural heritage."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site, are rock-cut monuments located on Elephanta Island. Dating back to the 5th–8th centuries, they feature sculptures dedicated primarily to Lord Shiva, including the massive Trimurti, Nataraja, and various mythological carvings. Visitors reach the island via ferry from the Gateway of India, experiencing a mix of history, art, and natural beauty."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a vibrant stretch along the Arabian Sea, known for its street food stalls, camel rides, kite flying, and sunset views. Locals and tourists enjoy pav bhaji, bhel puri, and ice creams while watching performers. The beach is lively during evenings and weekends, making it a perfect destination for families, couples, and photography enthusiasts looking to experience Mumbai’s coastal culture."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a cable-stayed bridge connecting Mumbai’s western suburbs to South Mumbai. A marvel of modern engineering, it offers stunning panoramic views of the Arabian Sea and city skyline. The bridge reduces travel time and is especially photogenic during sunrise, sunset, and night when illuminated. It symbolizes Mumbai’s urban development and infrastructural growth."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar is one of Mumbai’s oldest flea markets, famous for antiques, vintage Bollywood memorabilia, furniture, and collectibles. The bustling lanes offer an exciting shopping experience for collectors, photographers, and curious tourists. Bargaining, exploring hidden treasures, and absorbing the market’s chaotic charm make it a must-visit for those seeking cultural immersion and unique souvenirs."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park spans over 100 sq km in northern Mumbai and is a lush wildlife sanctuary. Home to leopards, deer, monkeys, and hundreds of bird species, it also includes trekking trails, boating, and the ancient Kanheri Caves. The park offers an escape from urban life, providing opportunities for wildlife photography, nature walks, and adventure, making it one of Mumbai’s most important ecological and recreational sites."
  }
],




"services": [
  {
    "name": "Carens Taxi Rental Mumbai",
    "description": "Reliable Carens taxi rental service in Mumbai for local, outstation, and airport travel."
  },
  {
    "name": "Kia Carens Cab Mumbai",
    "description": "Comfortable Kia Carens cab service in Mumbai for family trips and corporate travel."
  },
  {
    "name": "Carens 7-Seater Hire Mumbai",
    "description": "Spacious 7-seater Carens cab for group travel, family trips, and long-distance journeys."
  },
  {
    "name": "Carens Outstation Cab Mumbai",
    "description": "Carens Outstation cab service from Mumbai for long-distance travel to nearby cities."
  },
  {
    "name": "Carens Local Taxi Mumbai",
    "description": "Local Carens taxi service in Mumbai for city rides and point-to-point travel."
  },
  {
    "name": "Carens Airport Cab Mumbai",
    "description": "Carens cab for safe and timely airport pickup and drop in Mumbai."
  },
  {
    "name": "Premium Carens Cab Mumbai",
    "description": "Premium Carens cab service for luxury travel, long trips, and special occasions."
  },
  {
    "name": "Corporate Carens Rental Mumbai",
    "description": "Corporate Carens rental for office commute and business trips in Mumbai."
  },
  {
    "name": "Affordable Carens Taxi Mumbai",
    "description": "Budget-friendly Carens taxi service in Mumbai without compromising on comfort."
  },
  {
    "name": "Carens Family Cab Mumbai",
    "description": "Comfortable Carens cab for family trips and group travel around Mumbai."
  },
  {
    "name": "24x7 Carens Cab Mumbai",
    "description": "24x7 Carens cab service in Mumbai ensuring availability anytime."
  },
  {
    "name": "Carens Chauffeur Car Mumbai",
    "description": "Professional chauffeur-driven Carens service in Mumbai for safe and hassle-free rides."
  },
  {
    "name": "Long Distance Cab Carens Mumbai",
    "description": "Carens cab ideal for long trips from Mumbai with experienced drivers and comfortable seating."
  },
  {
    "name": "Safe Carens Cab Mumbai",
    "description": "Safe and reliable Carens cab service for all kinds of travel in Mumbai."
  },
  {
    "name": "Luxury Carens Cab Mumbai",
    "description": "Luxury Carens cab service in Mumbai for a premium travel experience."
  },
  {
    "name": "Carens MPV on Rent Mumbai",
    "description": "Rent Carens MPV in Mumbai for group travel, family trips, and long journeys."
  }
],

"tableData": [
  ["Carens Taxi Rental Mumbai", "Kia Carens Cab Mumbai"],
  ["Carens 7-Seater Hire Mumbai", "Carens Outstation Cab Mumbai"],
  ["Carens Local Taxi Mumbai", "Carens Airport Cab Mumbai"],
  ["Premium Carens Cab Mumbai", "Corporate Carens Rental Mumbai"],
  ["Affordable Carens Taxi Mumbai", "Carens Family Cab Mumbai"],
  ["24x7 Carens Cab Mumbai", "Carens Chauffeur Car Mumbai"],
  ["Long Distance Cab Carens Mumbai", "Safe Carens Cab Mumbai"],
  ["Luxury Carens Cab Mumbai", "Carens MPV on Rent Mumbai"]
],


"whychoose": [
  {
    "WhyChooseheading": "Kia Carens On Rent in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers Kia Carens on rent in Mumbai, perfect for family trips, airport transfers, business travel, and comfortable city or outstation journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, and air-conditioned Kia Carens cars that are regularly serviced to ensure a safe and smooth ride in Mumbai."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers ensure timely pickups, safe driving, and a hassle-free experience while you explore Mumbai or travel to nearby destinations."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We offer clear, upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Kia Carens rental."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel plans, and any inquiries related to your Kia Carens rental in Mumbai."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans based on your travel needs within Mumbai or for outstation trips."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every rental, ensuring a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Kia Carens rental in Mumbai comfortable, convenient, and stress-free."
  }
]



































  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide Kia Carens on rent in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers the Kia Carens on rent in Mumbai, providing a comfortable and stylish ride for families and group trips with ample space and premium features.',
  },
  {
    question: 'How can I rent a Kia Carens in Mumbai?',
    answer: 'You can easily rent a Kia Carens in Mumbai through our website, mobile app, or by contacting our 24x7 customer support team for a seamless and efficient booking experience.',
  },
  {
    question: 'What is the seating capacity of the Kia Carens on rent in Mumbai?',
    answer: 'The Kia Carens can comfortably accommodate up to 7 passengers, making it perfect for family outings, group trips, or corporate travel in Mumbai.',
  },
  {
    question: 'Are the Kia Carens vehicles well-maintained for rent in Mumbai?',
    answer: 'Yes, all our Kia Carens vehicles are regularly serviced, thoroughly cleaned, and well-maintained to ensure a smooth, safe, and enjoyable ride.',
  },
  {
    question: 'Can I customize the pickup and drop-off locations for the Kia Carens rental in Mumbai?',
    answer: 'Yes, you can specify your preferred pickup and drop-off locations within Mumbai, offering you flexibility and convenience for your journey.',
  },
  {
    question: 'Is the Kia Carens rental service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides 24x7 Kia Carens rental services in Mumbai, allowing you to travel at any time that suits your schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Kia Carens rentals in Mumbai?',
    answer: 'Yes, all our Kia Carens vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure your safety and comfort during the trip.',
  },
  {
    question: 'What payment options are available for Kia Carens rental in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all Kia Carens rentals in Mumbai.',
  },
  {
    question: 'Is customer support available for my Kia Carens rental in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers 24x7 customer support to assist you with any queries or issues during your Kia Carens rental experience in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajiv Kumar',
    feedback: 'I rented the Kia Carens for a weekend trip in Mumbai, and it was a great choice. The car was spacious, comfortable, and equipped with all the modern amenities. Will definitely rent again!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Singh',
    feedback: 'The Kia Carens I rented from Shambhu Cabs was perfect for our family trip. It was roomy, well-maintained, and the driver was very professional. Highly recommend their service.',
    rating: 5,
  },
];



















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const carensRentalMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Kia Carens On Rent Mumbai",
  "serviceType": "Car Rental Service",
  "image": "https://www.shambhucab.com/assets/images/kia-carens-rental-mumbai.jpg",
  "description": "Shambhu Cabs offers Kia Carens on rent in Mumbai. Book Carens 7-seater cabs for local rides, airport transfers, outstation trips, corporate travel, or family trips. Available 24×7 with premium and affordable options.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "870",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/kia-carens-on-rent-mumbai"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, India" }
};






  return (
    <div>
<Helmet>
  <title>Kia Carens On Rent Mumbai | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Kia Carens on rent in Mumbai with Shambhu Cabs. Available for airport transfer, local rides, outstation trips, corporate travel, and family trips. 24×7 service with premium and affordable options."
  />

  <meta
    name="keywords"
    content="Carens Taxi Rental Mumbai, Kia Carens Cab Mumbai, Carens 7-Seater Hire Mumbai, Carens Outstation Cab Mumbai, Carens Local Taxi Mumbai, Carens Airport Cab Mumbai, Premium Carens Cab Mumbai, Corporate Carens Rental Mumbai, Affordable Carens Taxi Mumbai, Carens Family Cab Mumbai, 24x7 Carens Cab Mumbai, Carens Chauffeur Car Mumbai, Long Distance Cab Carens Mumbai, Safe Carens Cab Mumbai, Luxury Carens Cab Mumbai, Carens MPV on Rent Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(carensRentalMumbaiSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kiacarensonrentinmumbai;